import {createFileRoute} from '@tanstack/react-router'
import CourtsEditPage from "../../../../../user/courts/Edit.tsx";

export const Route = createFileRoute('/_app/clubs/$club_uid/courts/$court_uid')({
    component: RouteComponent,
})

function RouteComponent() {
    return <CourtsEditPage />
}
